import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule} from '@angular/forms';
import { FormsModule } from "@angular/forms";
import { NgxMaskModule, IConfig } from 'ngx-mask';
import {NgxWebstorageModule} from 'ngx-webstorage';
import { VendorOnboardingRoutingModule } from './vendor-onboarding-routing.module';
import { CompanyprofileOnboarddocumentComponent } from './components/companyprofile-onboarddocument/companyprofile-onboarddocument.component';
import {TableModule} from 'primeng/table';
import {ToastModule} from 'primeng/toast';
import {CalendarModule} from 'primeng/calendar';
import {SliderModule} from 'primeng/slider';
import {MultiSelectModule} from 'primeng/multiselect';
import {ContextMenuModule} from 'primeng/contextmenu';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {ProgressBarModule} from 'primeng/progressbar';
import {InputTextModule} from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import {MessagesModule} from 'primeng/messages';
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { CardModule } from 'primeng/card';
import { PanelModule } from "primeng/panel";

import {InputSwitchModule} from 'primeng/inputswitch';
import {CheckboxModule} from 'primeng/checkbox';
import {TabViewModule} from 'primeng/tabview';
import {FileUploadModule} from 'primeng/fileupload';
import { ChartsModule,ThemeService } from 'ng2-charts';
import {PasswordModule} from 'primeng/password';
import {TabMenuModule} from 'primeng/tabmenu';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {AvatarModule} from 'primeng/avatar';
import {AvatarGroupModule} from 'primeng/avatargroup';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import {AccordionModule} from 'primeng/accordion';
import {EditorModule} from 'primeng/editor';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxDocViewerModule } from 'ngx-doc-viewer'; 
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { FiltersModule } from '../filters/filters.module';

import { QuillModule } from 'ngx-quill';
import { CtoccompanyOnboardingdocumentNcaComponent } from './components/ctoccompany-onboardingdocument-nca/ctoccompany-onboardingdocument-nca.component';
@NgModule({
  declarations: [CompanyprofileOnboarddocumentComponent, CtoccompanyOnboardingdocumentNcaComponent],
  imports: [
    CommonModule,
    VendorOnboardingRoutingModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    PasswordModule,

    ChartsModule,
    TableModule,
    CalendarModule,
		SliderModule,
		DialogModule,
		MultiSelectModule,
		ContextMenuModule,
		DropdownModule,
		ButtonModule,
		ToastModule,
    InputTextModule,
    ProgressBarModule,
    MenuModule,
    MenubarModule,
    CardModule,
    PanelModule,
    TabViewModule,
    InputSwitchModule,
    CheckboxModule,
    MessagesModule,
    FileUploadModule,
    ConfirmPopupModule,
    TabMenuModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    AvatarModule,
    AvatarGroupModule,
    AccordionModule,
    EditorModule,
    NgxMaskModule.forRoot(),
    NgxWebstorageModule.forRoot(),
    PdfViewerModule,
    NgxDocViewerModule,
    ProgressSpinnerModule,
    FiltersModule,
    QuillModule.forRoot(),
  ]
})
export class VendorOnboardingModule { }
